import { InfoCircleOutlined } from '@ant-design/icons';
import { type LabelTooltipType } from 'antd/es/form/FormItemLabel';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
    padding: 0.5rem;

    & > ul {
        margin-bottom: 0;
        padding-left: 1rem;
    }
`;

const useExternalModelInfoTooltip = (): LabelTooltipType => {
    const { t } = useTranslation('mobilityModuleDetails');

    return {
        title: <Container>{t('mobilityModuleDetails:messages.externalModelInfo')}</Container>,
        icon: <InfoCircleOutlined />,
        overlayInnerStyle: { minWidth: '18rem' },
    };
};

export default useExternalModelInfoTooltip;
